<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Qes64i/tc-custom/9781605507057.jpg?1730492329553" alt="This image is the cover for the book Everything Ghost Hunting Book, The Everything Books"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Everything Ghost Hunting Book, The Everything Books
      </h1>
      <p class="bookDescription body article font2">
        <b>Shadowpeople .</b>.. cold spots ... orbs. Ghosthunter Melissa Martin Ellis takes readers on an exciting high-tech journey into the supernatural world of haunted sites, restless souls, and messages from beyond the grave. Readers explore motion sensors, highly sensitive digital cameras, and so-called Ghost Telephones, as well as the supernatural phenomena themselves, including:PoltergeistsElectronic-voice phenomena (EVP)PossessionPhoto anomaliesSéances and voodoo rituals Appealing to the same audience as such popular TV shows as <i>Lost</i>, <i>Medium</i>, <i>Invasion</i>, <i>Charmed</i>, <i>Ghost Hunters</i>, <i>Destination Truth</i>, and <i>Most Haunted</i>, this book shows readers how today's investigators use the tools of modern science to study a wide range of paranormal activity.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Melissa Martin Ellis
      </h2>
      
      <p class="authorDescription body article">An Adams Media author.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Adams Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?22586338